import React, { useMemo } from 'react'
import { RichTextBlock } from 'prismic-reactjs'
import WebinarsSection from '../../sections/WebinarsSection'
import { WebinarsSliceProps } from './types'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import usePageContext from '../../../hooks/usePageContext'
import { mapButtonProps } from '../../atoms/Button/utils'

const WebinarsSlice: React.FC<WebinarsSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { w_title, w_is_main_heading, w_date_label, w_time_label } = primary || {}

  const { group } = usePageContext()

  const data = useMemo(
    () =>
      items.map((item, index) => {
        const {
          w_item_title,
          w_item_description,
          w_item_date,
          w_item_time,
          w_items_title,
          w_items,
          w_cta_type,
          w_cta_text,
          w_cta_link,
          w_cta_is_centered,
          w_cta_caption,
          w_cta_caption_mobile_size,
          w_cta_caption_desktop_size
        } = item || {}

        const list = (w_items?.raw || []).map((item: RichTextBlock, index) => ({
          key: `webinar-list-${index}`,
          text: item?.text || ''
        }))

        return {
          key: `webinar-${index}`,
          title: w_item_title?.text,
          dateLabel: {
            name: w_date_label,
            value: w_item_date
          },
          timeLabel: {
            name: w_time_label,
            value: w_item_time
          },
          content: {
            description: w_item_description?.text,
            heading: w_items_title,
            list,
            cta: mapButtonProps(
              w_cta_type,
              w_cta_text,
              resolvePrismicLink(w_cta_link, group),
              w_cta_link?.link_type,
              w_cta_caption,
              w_cta_caption_mobile_size,
              w_cta_caption_desktop_size,
              w_cta_is_centered
            )
          }
        }
      }),
    [items, w_date_label, w_time_label, group]
  )

  return (
    <WebinarsSection
      heading={w_title?.text}
      isMainHeading={w_is_main_heading}
      headingPadding={['60px', '', '130px']}
      inner="inners.primary"
      paddingTop={['38px', '', '90px']}
      paddingBottom={['80px', '', '50px']}
      data={data}
      bgColor="#F8FAFF"
    />
  )
}

export default WebinarsSlice
